import Header from "@/components/Header";
import Footer from "@/components/Footer";
import OrderWizard from "@/components/order/OrderWizard";
import SEOHead from "@/components/SEOHead";

const Order = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="주문하기 - Central TG | JAX® 모델 간편 주문"
        description="JAX transgenic 마우스 모델을 간편하게 주문하세요. 전문가 상담과 함께 연구에 최적화된 모델을 추천받으실 수 있습니다."
        keywords="JAX 모델 주문, transgenic 마우스 구매, 실험동물 주문, 연구용 마우스 구입, 온라인 주문, 견적 요청"
        canonical="https://centraltg.co.kr/order"
      />
      <Header />
      
      <main>
        <OrderWizard />
      </main>

      <Footer />
    </div>
  );
};

export default Order;